import React, { Component } from 'react';

class Adsense700250 extends Component {

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    return (
      <ins className="adsbygoogle"
        style={{display:'inline-block', width: '700px', height: '250px'}}
        data-ad-client="ca-pub-1407998984163880"
        data-ad-slot="5950041429"
      ></ins>
    );
  }
}

export default Adsense700250;